import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';

import { AppComponent } from './app.component';
import { appDeclarations } from './appdeclarations';
import { appRoutes } from './approutes';
import { appProviders } from './appproviders';

@NgModule({
  declarations: appDeclarations,
  imports: [
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserModule,
    RouterModule.forRoot(appRoutes),
    BrowserAnimationsModule,
    CarouselModule,
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule
  ],
  providers: appProviders,
  bootstrap: [AppComponent]
})
export class AppModule { }
